/** Mirrors `core/passwords.MIN_LENGTH` (the server re-checks). */
export const MIN_PASSWORD_LENGTH = 12

/** The invite/reset token rides in the URL FRAGMENT (`#token=…`) so it never
 *  reaches a server log or a Referer header. */
export function tokenFromHash(hash: string): string {
  return new URLSearchParams(hash.replace(/^#/, '')).get('token') ?? ''
}
